import { Group, SimpleGrid, Skeleton, Stack } from 'components'

const GRID_BREAKPOINTS = [
  { maxWidth: 'md', cols: 2 },
  { maxWidth: 'sm', cols: 1 },
]

const PersonRowSkeleton = () => (
  <Group spacing='sm' noWrap>
    <Skeleton height={40} width={40} circle />
    <Skeleton height={12} width='70%' radius='sm' />
  </Group>
)

const Section = ({ rows }: { readonly rows: number }) => (
  <Stack spacing='md'>
    <Skeleton height={20} width={140} radius='sm' />
    <SimpleGrid cols={4} breakpoints={GRID_BREAKPOINTS} spacing='sm'>
      {Array.from({ length: rows }).map((_, idx) => <PersonRowSkeleton key={idx} />)}
    </SimpleGrid>
  </Stack>
)

export const ParticipantsSkeleton = () => (
  <Stack spacing='xl'>
    <Section rows={2} />
    <Section rows={8} />
  </Stack>
)
